import { useState, useContext } from "react";
import {
  Grid,
  Stack,
  Dialog,
  DialogContent,
  Typography,
  Avatar,
} from "@mui/material";
import { pdfjs } from "react-pdf";
// Project imports
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DialogTitleComp } from "../../../Utils/Component";
import PdfViewerBig from "../../../Utils/PdfViewerBig";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function ViewExam({
  open,
  row,
  editData,
  handleClose,
  language,
}) {
  const { t } = useContext(AuthContext);

  return (
    <Dialog open={open} className="dialog-container" fullScreen>
      <DialogTitleComp
        title={t("modal_title_view_exam")}
        classTitle="dialog-title"
        classIcon="close-icon"
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Stack direction="column" spacing={2}>
              <Stack direction="row" spacing={1.4}>
                <Stack direction="column" justifyContent="center">
                  <Avatar
                    sx={{ width: 40, height: 40 }}
                    alt={row?.studentId?.studentName}
                    src={row?.studentId?.profile}
                  />
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Typography className="student-name">
                    {row?.studentId?.familyName +
                      " " +
                      row?.studentId?.studentName}
                  </Typography>
                </Stack>
              </Stack>
              <Typography>
                {language === "en"
                  ? editData?.subjectId?.enName
                  : editData?.subjectId?.khName}
              </Typography>
              <Typography>{editData?.exercise}</Typography>
              <Typography>{editData?.score}</Typography>
            </Stack>
          </Grid>
          <Grid item xs={8}>
            <Stack direction="row" justifyContent="center">
              <PdfViewerBig pdf={editData?.file} />
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
